import React from 'react';
import { Layout, Menu, Icon } from 'antd';
import s from './style.less';

const { Sider } = Layout;
const { SubMenu } = Menu;

class InnerSider extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      history: props.history || {},
      collapsed: false,
      selectedKeys: [`${this.formatPath(props.history.location.pathname)}`],
      siderList: props.siderList || [],
      siderTitle: props.title || [],
      openKeys: [],
      miniOpenKeys: [],
      idToIcon: {
        BA: 'profile', // 交易管理
        BB: 'pay-circle-o', // 结算管理
        EA: 'user', // 操作员权限管理
        B: 'td-center',
        E: 'pay-circle-o',
      },
    };
  }

  componentWillReceiveProps(nextprops) {
    const arr = [];
    const pathname = this.formatPath(nextprops.history.location.pathname);
    nextprops.siderList.forEach((item, idx) => {
      // if (idx === 0) {
      arr.push(item.path);
      // }

      const children = item.children || [];
      if (children.length > 0) {
        item.children.forEach((subitem) => {
          arr.push(subitem.path);
        });
      }
    });
    // const arr = this.filterOpenKeys(nextprops.history.location.pathname, nextprops.siderList);
    this.setState({
      siderList: nextprops.siderList,
      siderTitle: nextprops.title,
      openKeys: arr,
      selectedKeys: [`${this.formatPath(nextprops.history.location.pathname)}`],
    });
  }

  onCollapse = (collapsed) => {
    this.setState({ collapsed });
  }

  filterOpenKeys = (openkey, siderList) => {
    const pathname = this.formatPath(openkey);
    const arr = [];
    siderList.forEach((item, idx) => {
      if (pathname.split(item.path).length > 1) {
        arr.push(item.path);
      }

      const children = item.children || [];
      if (children.length > 0) {
        item.children.forEach((subitem) => {
          if (pathname.split(subitem.path).length > 1) {
            arr.push(subitem.path);
          }
        });
      }
    });

    return arr;
  }

  formatPath = (path) => {
    const arr = path.split('/');
    const result = [];
    arr.forEach((item, i) => {
      if (item.split(':').length > 1) {
        item = ':id';
      }
      if (i <= 3) {
      // if (i <= 4) {
        result.push(item);
      }
    });
    return result.join('/');
  }

  handleClick = (item) => {
    if (this.props.history.location.pathname !== item.key) {
      this.setState({
        selectedKeys: [item.key],
        // openKeys: this.filterOpenKeys(item.key, this.props.siderList),
      }, () => {
        this.state.history.push(item.key);
      });
    }
    // 帮助中心跳转外链
  }

  handleOpenChange = (openKeys) => {
    console.log(openKeys);
    // console.log(openKeys[openKeys.length - 1]);
    // const len = openKeys[openKeys.length - 1].split('/').length;
    // let arr = [];
    // if (len === 3) {
    //   openKeys.forEach((item, idx) => {
    //     console.log(item);
    //     const itemLen = item.split('/').length;
    //     if (itemLen !== 3) {
    //       arr.push(item);
    //     }
    //   });
    //   arr.push(openKeys[openKeys.length - 1]);
    // } else {
    //   arr = openKeys;
    // }
    // this.setState({
    //   openKeys: arr,
    // });

    if (this.state.collapsed) {
      this.setState({
        miniOpenKeys: openKeys,
      });
    } else {
      this.setState({
        openKeys,
      });
    }
  }

  toggleSiderBar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    }, () => {
      this.props.onToggle(this.state.collapsed);
    });
  }

  toggleSiderBar = () => {
    this.setState({
      collapsed: !this.state.collapsed,
    }, () => {
      this.props.onToggle(this.state.collapsed);
    });
  }

  render() {
    // console.log(this.props.siderList);
    return (
      this.props.isShow ?
        <Sider
          className={`${s.wrap} siderBar`}
          collapsed={this.state.collapsed}
          collapsible
          trigger={null}
          onCollapse={this.onCollapse}
          style={this.props.style}
        >
          {
            this.state.collapsed ?
              <h3 className={s.siderTitleMini}>
                <Icon
                  type="menu-unfold"
                  theme="outlined"
                  onClick={this.toggleSiderBar}
                  style={{ cursor: 'pointer' }}
                />
              </h3>
              :
              <h3 className={s.siderTitle}>
                {/* {this.state.siderTitle} */}
                菜单导航
                <Icon
                  type="menu-fold"
                  theme="outlined"
                  onClick={this.toggleSiderBar}
                  style={{ float: 'right', margin: '13px', cursor: 'pointer' }}
                />
              </h3>
          }
          <Menu
            selectedKeys={this.state.selectedKeys}
            openKeys={this.state.collapsed ? this.state.miniOpenKeys : this.state.openKeys}
            inlineCollapsed
            mode="inline"
            style={{ borderRight: 0 }}
            onClick={this.handleClick}
            onOpenChange={this.state.collapsed ? this.handleOpenChange : null}
          >
            {
              this.props.siderList.map((item) => {
                let view = null;
                const children = item.children || [];
                if (children.length > 0) {
                  view = (
                    // 1级
                    <SubMenu
                      key={item.path}
                      title={
                        <span>
                          {/* <Icon type={this.state.idToIcon[item.id] || 'user'} /> */}
                          <i className={`anticon siderBarIcon sdicon-${item.id}`}></i>
                          <span
                            style={{
                              color: this.state.selectedKeys[0].split(item.path).length > 1 && this.state.collapsed ? '#fff' : '',
                              fontSize: '16px',
                            }}
                          >{item.name}</span>
                        </span>}
                      style={{
                        background: this.state.selectedKeys[0].split(item.path).length > 1 && this.state.collapsed ? '#1890FF' : '',
                      }}
                      className={`${this.state.selectedKeys[0].split(item.path).length > 1 ? 'inselected' : ''}`}
                    >
                      {item.children.map((subitem) => {
                        let subview = null;
                        if (subitem.children.length > 0) {
                          subview = (
                            // 2级
                            <SubMenu
                              key={subitem.path}
                              title={subitem.name}
                            >
                              {
                                subitem.children.map((thditem) => {
                                  return (
                                    // 3级
                                    <Menu.Item
                                      className={s.nenuItem}
                                      key={thditem.redirectFullPath}
                                    >
                                      {thditem.name}
                                    </Menu.Item>);
                                })
                              }
                            </SubMenu>
                          );
                        } else {
                          subview = (
                            <Menu.Item
                              className={s.nenuItem}
                              key={subitem.path}
                            >
                              {subitem.name}
                            </Menu.Item>);
                        }
                        return subview;
                      })}
                    </SubMenu>
                  );
                } else {
                  view = (
                    <Menu.Item key={item.path}>
                      <Icon type={this.state.idToIcon[item.id] || 'user'} />
                      <span>{item.name}</span>
                    </Menu.Item>
                  );
                }
                return view;
              })}
          </Menu>
        </Sider>
        :
        null
    );
  }
}

export default InnerSider;



// WEBPACK FOOTER //
// ./src/views/MainLayout/SiderBar/SiderBar.jsx